import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BookYourLongueuilService() {
  return <section data-section-id="252573" id="strategicconsultationcta" className="bg-primary py-20 md:py-32 border-y border-secondary/30">
      <div className="page-container flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-5xl font-bold text-white mb-6 max-w-3xl leading-tight tracking-tight">
          Consulenza Strategica per la Mobilità Internazionale
        </h2>
        
        <p className="font-default text-lg md:text-xl text-white/90 mb-10 max-w-2xl">
          Affidatevi a professionisti esperti per la gestione dei vostri visti e documenti globali. Garantiamo affidabilità e successo per il vostro business nel mondo.
        </p>
        
        <Button asChild size="lg" className="h-14 px-8 text-lg font-bold shadow-xl rounded-lg bg-[#FFC829] text-primary hover:bg-[#FFC829]/90 transition-all duration-300">
          <Link to="/ContactsPage">
             Richiedi Consulenza
          </Link>
        </Button>
      </div>
    </section>;
}